export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';

export const FRIENDLY_DATE_FORMAT = 'ddd D MMM YYYY';
